import React from 'react';
import { Container, Navbar } from 'react-bootstrap';
import uniqid from 'uniqid';


export interface INavLinkProps {
    route: string,
    name: string
}

export const NavBar = () => {
    return (
        <Navbar bg="white" variant="dark" expand="xl" id={uniqid()}>
            <Container fluid>
                <Navbar.Brand className="petco-logo"></Navbar.Brand>
            </Container>
        </Navbar>
    );
}


export default NavBar;
